var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hm-balance"},[(Number(_vm.balance) === 0)?_c('span',{staticClass:"hm-balance__paid"},[_c('PaidIcon'),_vm._v(" Paid ")],1):_c('span',{staticClass:"hm-balance__value",class:{
      'hm-balance__value--neg': Number(_vm.balance) < 0,
      'hm-balance__value--pos': Number(_vm.balance) > 0
    }},[_vm._v(" "+_vm._s(_vm.formatMoney(_vm.balance))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }